import React from 'react';
export function Footer() {
  return <footer className="w-full border-t border-white/10 bg-ink pb-24 pt-8 text-white/50 md:pb-8" data-id="element-159" data-mp="32wmqrybuniwl">
      <div className="mx-auto max-w-6xl space-y-2 px-5 text-center text-xs leading-relaxed" data-id="element-160" data-mp="3ggu1cr6lbz9g">
        <p data-id="element-161" data-mp="32pfgsfx1bq0a">
          Kit Ingresos Online es un producto educativo. No garantizamos ingresos ni resultados económicos: los
          resultados dependen de capital, mercado, ejecución, experiencia, costos, tiempo y otras variables.
        </p>
        <p data-id="element-162" data-mp="38qyt7e9m7ve">El arbitraje y las operaciones con criptomonedas implican riesgos. Informate sobre la regulación vigente.</p>
        <p data-id="element-163" data-mp="3lf58gu5i3vnz">© {new Date().getFullYear()} Kit Ingresos Online. Todos los derechos reservados.</p>
      </div>
    </footer>;
}